import { render, staticRenderFns } from "./printBatch.vue?vue&type=template&id=506a8504&scoped=true&"
import script from "./printBatch.vue?vue&type=script&lang=js&"
export * from "./printBatch.vue?vue&type=script&lang=js&"
import style0 from "./printBatch.vue?vue&type=style&index=0&id=506a8504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a8504",
  null
  
)

export default component.exports